module.exports = require('./helpers/bundle-url').getBundleURL('iqneu') + "logo-dark.eefe0b7f.svg";